import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Checkbox = ({
  label,
  name,
  register,
  setValue,
  watch,
  error,
  className = "",
  fieldHeight = "medium",
}) => {
  const isChecked = watch(name);

  const handleChange = (e) => {
    setValue(name, e.target.checked);
  };

  // Get checkbox size classes based on fieldHeight
  const getCheckboxSizeClasses = () => {
    switch (fieldHeight) {
      case "small":
        return {
          checkbox: "min-w-5 min-h-5 w-5 h-5",
          checkmark: "min-w-2.5 min-h-1 -mt-0.5 w-2.5 h-1",
          spacing: "pl-2",
        };
      case "large":
        return {
          checkbox: "min-w-7 min-h-7 w-7 h-7",
          checkmark: "min-w-4 min-h-2 -mt-1 w-4 h-2",
          spacing: "pl-3",
        };
      case "medium":
      default:
        return {
          checkbox: "min-w-6 min-h-6 w-6 h-6",
          checkmark: "min-w-3 min-h-1.5 -mt-1 w-3 h-1.5",
          spacing: "pl-2.5",
        };
    }
  };

  const sizeClasses = getCheckboxSizeClasses();

  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex items-center">
        <input
          type="checkbox"
          id={name}
          checked={!!isChecked}
          onChange={handleChange}
          className={clsx(
            "absolute -z-10 opacity-0 [&+label>.radio]:border-gray-200 [&+label>.radio]:text-transparent [&:checked+label>.radio]:border-[rgba(var(--primary-rgb)/100%)] [&:checked+label>.radio]:text-[rgba(var(--primary-rgb)/100%)]"
          )}
        />
        <label htmlFor={name} className="inline-flex cursor-pointer">
          <span className={`radio border ${sizeClasses.checkbox} rounded-lg flex items-center justify-center`}>
            {isChecked && (
              <span className={`block ${sizeClasses.checkmark} border-b-2 border-l-2 border-[currentColor] -rotate-45`}></span>
            )}
          </span>
          <span className={`${sizeClasses.spacing} text-gray-700`}>{label}</span>
        </label>
      </div>
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  register: PropTypes.func, // still needed for RHF validation
  setValue: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  error: PropTypes.object,
  className: PropTypes.string,
  fieldHeight: PropTypes.string,
};

export default Checkbox;
